import { Component, OnInit, inject } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { WopiDebugDataService } from "./services/wopi-debug-data.service";

@Component({
    selector: "wopi-debug",
    templateUrl: "./wopi-debug.component.html",
    styleUrls: ["./wopi-debug.component.scss"],
    standalone: false
})
export class WopiDebugComponent implements OnInit {
    private _ds = inject(WopiDebugDataService);

    tab: TabModel;
    enabled: boolean;

    async ngOnInit() {
        await this.init();
    }

    async init() {
        this.enabled = await this._ds.enabled();
    }
}
